<template>
    <div>
    <!-- Product content -->
    <div class="preview-img-div rx">
        <img sizes="(max-width: 479px) 45vw, 261px"  :src="getProductImage(product.image_pre_text)" loading="lazy" class="preview-image" @click.prevent="moveToProductPage(product.url)">
        <img loading="lazy" src="@/assets/images/icon_-RX-black.svg" alt="" class="image-403" v-if="product.is_prescription==1">
        <img loading="lazy" src="@/assets/images/leaf-p.png" alt="" class="image-403" v-else>
        <div  :class="`text-block-777 ${product.category.primary.toLowerCase()}`">
            {{ product.category.primary }}
        </div>
    </div>
    <div class="preview-details-div">
        <div class="preview-header-div">
            <div class="product-name-div">
                <div class="text-block-778">{{ product.name }}</div>
                <div class="text-block-779">{{ product.brand_name }}</div>
            </div>
            <div class="preview-price-div">
                <div class="preview-price">
                    <div class="dollar">$</div>
                    <div class="product-amount">{{ parseFloat(product.pricing.retail_price).toFixed(2) }}</div>
                </div>
                <div class="daily-price">(${{ calculateDailyPrice(product.pricing.retail_price) }} a Day)</div>
            </div>
        </div>
        <div class="text-block-780">{{ truncateDescription(product.marketing.sub_header) }}</div>
        <div class="preview-button-div" :class="{'add-margin' : page==='product'}">
            <a href="#" class="learn-more-button w-button" :tabindex="index < currentSlide || index >= currentSlide + itemsPerSlide ? -1 : 0">
                Learn More
            </a>
            <router-link :to="{ 
                    name: 'productPage',  // assuming 'product' is the route name
                    params: { 
                        productName: product.url
                    }
                }" title="View Details" class="mobile-learn-more-button w-inline-block hide-from-mobile" :tabindex="index < currentSlide || index >= currentSlide + itemsPerSlide ? -1 : 0">
                <div class="text-block-781">?</div>
            </router-link>
            <a href="#" @click.prevent="handleAddToCart(product)" class="preview-add-to-cart w-button" :tabindex="index < currentSlide || index >= currentSlide + itemsPerSlide ? -1 : 0">
                ADD TO CART
            </a>
        </div>
    </div>
</div>
</template>

<script>
import {
    createUrlName
} from '@/utils/productData';
import {
    mapActions
} from 'vuex';

export default {
    name: 'ProductCard',

    props: {
        product: {
            type: Object,
            required: true,
            default: () => ({})
        },
        page: {
            type: String,
            required: true,
            default: 'shop'
        },
        index:{
            type: Number,
            required: true,
            default : 1
        }
    },

    data() {
        return {
            currentSlide: 0,
            itemsPerSlide: window.innerWidth < 768 ? 2 : 4,
            isAnimating: false,
            slideWidth: 0
        };
    },

    computed: {
        getProductsWithHelp() {
            const slides = [];
            const productsCopy = [...this.products];
            productsCopy.forEach(element => {
                slides.push({
                    element_type: 'product',
                    ...element
                });

                if (slides.length % 3 === 0) {
                    slides.push({
                        element_type: 'help',
                    });
                }
            });

            return slides;
        },

        totalSlides() {
            return this.getProductsWithHelp.length;
        },

        slideStyles() {
            return (index) => {
                const isVisible = index >= this.currentSlide && index < this.currentSlide + this.itemsPerSlide;
                return {
                    transition: 'all, transform 500ms',
                    transform: `translateX(${-this.currentSlide * this.slideWidth}px)`,
                    opacity: isVisible ? 1 : 1,
                    'aria-hidden': !isVisible
                };
            };
        },

        currentPage() {
            return Math.floor(this.currentSlide / this.itemsPerSlide);
        },

        totalPages() {
            return Math.ceil(this.getProductsWithHelp.length / this.itemsPerSlide);
        },

        maxSlide() {
            return Math.max(0, this.getProductsWithHelp.length - this.itemsPerSlide);
        },

        ariaLiveText() {
            return `Slide ${this.currentPage + 1} of ${this.totalPages}.`;
        }
    },

    methods: {
        ...mapActions(['addToCart']),

        calculateDailyPrice(price) {
            return (parseFloat(price) / 30).toFixed(2);
        },
        moveToProductPage(url){
            this.$router.push({ 
                    name: 'productPage',  // assuming 'product' is the route name
                    params: { 
                        productName: url
                    }
                })
        },
        createUrlName,
        
        getProductImage(name){
            return `https://newselfrx.s3.us-east-1.amazonaws.com/public/assets/product_image/webp/${name}/1.webp`;
        },
        truncateDescription(description) {
            if (description && description.length > 60) {
                return description.slice(0, 60) + '...';
            }
            return description;
        },

        handleAddToCart(product) {
        
        // Create cart item explicitly
        const cartItem = {
                id: product.id,
                name: product.name,
                category: product.category.primary,
                price: parseFloat(product.pricing.retail_price).toFixed(2),
                retail_price: (parseFloat(product.pricing.retail_price) * 1.33).toFixed(2),
                subheader: product.brand_name,
                sku: product.sku,
                stripe_id: product.stripe_id,
                quantity: 1,
                image: `https://newselfrx.s3.us-east-1.amazonaws.com/public/assets/product_image/webp/${product.image_pre_text}/1.webp`,
                main_type: product.is_prescription
            };
        
        this.$store.dispatch('addToCart', cartItem);
    },

        previousSlide() {
            if (this.currentSlide > 0 && !this.isAnimating) {
                this.isAnimating = true;
                this.currentSlide = Math.max(0, this.currentSlide - this.itemsPerSlide);
                this.handleTransitionEnd();
            }
        },

        nextSlide() {
            if (this.currentSlide < this.maxSlide && !this.isAnimating) {
                this.isAnimating = true;
                this.currentSlide = Math.min(this.maxSlide, this.currentSlide + this.itemsPerSlide);
                this.handleTransitionEnd();
            }
        },

        handleTransitionEnd() {
            setTimeout(() => {
                this.isAnimating = false;
            }, 500);
        },

        goToPage(pageIndex) {
            if (!this.isAnimating) {
                this.isAnimating = true;
                this.currentSlide = pageIndex * this.itemsPerSlide;
                this.handleTransitionEnd();
            }
        },

        updateSlideWidth() {
            const sliderMask = document.querySelector('.mask-3');
            this.itemsPerSlide = window.innerWidth < 768 ? 2 : 4;
            if (sliderMask) {
                this.slideWidth = sliderMask.offsetWidth / this.itemsPerSlide;
            }
        }
    },

    mounted() {
        this.updateSlideWidth();
        window.scrollTo({ top: 0, behavior: 'smooth' })
        window.addEventListener('resize', this.updateSlideWidth);
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.updateSlideWidth);
    }
};
</script>

<style scoped>
@media (min-width: 769px) {
    .add-margin{
        margin-top: 15px;
        position: relative;
    }
}
@media screen and (max-width: 479px) {
    .preview-button-div {
        align-items: center;
        justify-content: center;
    }
}
</style>